import './elements/hamburger-menu.js';
import './elements/nav-submenu.js';
import './elements/accordion.js';
import './elements/swiper.js';
import './elements/swiper-gallery.js';


function loadPolyfills() {
  return Promise.all([]);
}

function bootApplication() {

}

function handleExceptions(error) {
  console.error('App init failed:', error);
}

loadPolyfills()
  .then(bootApplication)
  .catch(handleExceptions);


